export const teamMembers = [
    { name: 'Don Schmocker', role: 'Co-Founder, Art Director' },
    { name: 'Goran Saric', role: 'Co-Founder, Managing Director' },
    { name: 'Martina Hugentobler', role: 'Animation' },
    { name: 'Philipp Stern', role: 'Game & Level Design' },
    { name: 'Fabio Baumgartner', role: 'Game Design Lead, Sound Design' },
];
